import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Zap, Utensils, TrendingDown } from 'lucide-react';
const costData = [{
  without: 'Crear cada plan manualmente',
  cost: '2-4 horas por plan que harías en 15 minutos'
}, {
  without: 'Sin scripts de venta',
  cost: 'El 70% de los prospectos no se convierte'
}, {
  without: 'Sin producto empaquetado',
  cost: 'Ingresos limitados a tus horas disponibles'
}, {
  without: 'Sin contenido estratégico',
  cost: 'Dependencia total de referidos que no escala'
}, {
  without: 'Sin cobro automático',
  cost: 'Perdés ventas cuando no estás disponible'
}, {
  without: 'Sin membresía recurrente',
  cost: 'Empezás cada mes desde cero'
}];
export function CostTable() {
  return <section className="py-16 bg-graphite relative overflow-hidden" data-id="element-123">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-electric/5 blur-[120px] rounded-full pointer-events-none" data-id="element-124"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-125">
        {/* Framed Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-4xl mx-auto mb-12" data-id="element-126">
          <div className="absolute -inset-1 bg-gradient-to-r from-electric via-energy to-electric rounded-3xl blur-xl opacity-25 animate-pulse" data-id="element-127"></div>
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-electric rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-electric/20" data-id="element-128">
            {/* Decorative utensils flourish in background */}
            <div className="absolute -top-16 -right-16 opacity-10 pointer-events-none rotate-12" data-id="element-129">
              <Utensils className="w-48 h-48 text-electric" data-id="element-130" />
            </div>
            <div className="absolute -bottom-16 -left-16 opacity-10 pointer-events-none -rotate-12" data-id="element-131">
              <Utensils className="w-48 h-48 text-electric" data-id="element-132" />
            </div>

            {/* Organic dot pattern background */}
            <div className="absolute inset-0 opacity-[0.18] pointer-events-none" style={{
            backgroundImage: 'radial-gradient(circle, rgba(125,255,47,0.35) 1.2px, transparent 1.5px)',
            backgroundSize: '18px 18px'
          }} data-id="element-133"></div>
            <div className="absolute top-0 left-0 w-14 h-14 border-t-4 border-l-4 border-electric rounded-tl-3xl pointer-events-none" data-id="element-134"></div>
            <div className="absolute top-0 right-0 w-14 h-14 border-t-4 border-r-4 border-electric rounded-tr-3xl pointer-events-none" data-id="element-135"></div>
            <div className="absolute bottom-0 left-0 w-14 h-14 border-b-4 border-l-4 border-electric rounded-bl-3xl pointer-events-none" data-id="element-136"></div>
            <div className="absolute bottom-0 right-0 w-14 h-14 border-b-4 border-r-4 border-electric rounded-br-3xl pointer-events-none" data-id="element-137"></div>

            <div className="relative z-10" data-id="element-138">
              <div className="inline-flex items-center gap-2 bg-electric text-graphite px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-electric/40" data-id="element-139">
                <Utensils className="w-3.5 h-3.5" strokeWidth={2.5} data-id="element-140" />
                El costo real
              </div>
              <h2 className="text-2xl md:text-4xl font-extrabold leading-tight" data-id="element-141">
                <span className="text-white" data-id="element-142">¿Cuánto cuesta </span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric via-energy to-electric drop-shadow-[0_0_12px_rgba(125,255,47,0.4)]" data-id="element-143">
                  no tenerlo?
                </span>
              </h2>
              <div className="mt-4 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-electric to-transparent opacity-70" data-id="element-144"></div>
            </div>
          </div>
        </motion.div>

        {/* Desktop table */}
        <div className="max-w-3xl mx-auto mb-10 hidden md:block" data-id="element-145">
          <div className="bg-gradient-to-br from-petroleum to-graphite border border-electric/25 rounded-2xl overflow-hidden shadow-xl shadow-electric/5" data-id="element-146">
            <table className="w-full text-left border-collapse" data-id="element-147">
              <thead data-id="element-148">
                <tr className="bg-graphite/70" data-id="element-149">
                  <th className="p-5 border-b border-white/10 text-textsecondary font-semibold text-xs uppercase tracking-widest" data-id="element-150">
                    <span className="inline-flex items-center gap-2" data-id="element-151">
                      <span className="w-6 h-6 rounded-md bg-white/5 flex items-center justify-center" data-id="element-152">
                        <TrendingDown className="w-3.5 h-3.5" data-id="element-153" />
                      </span>
                      Sin el KIT
                    </span>
                  </th>
                  <th className="p-5 border-b-2 border-electric/40 text-electric font-extrabold text-xs uppercase tracking-widest bg-electric/5" data-id="element-154">
                    <span className="inline-flex items-center gap-2" data-id="element-155">
                      <span className="w-6 h-6 rounded-md bg-electric/20 flex items-center justify-center" data-id="element-156">
                        <AlertTriangle className="w-3.5 h-3.5" data-id="element-157" />
                      </span>
                      Costo real
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-158">
                {costData.map((row, i) => <tr key={i} className="border-b border-white/5 last:border-0 hover:bg-white/[0.02] transition-colors group" data-id="element-159">
                    <td className="p-5 text-white font-medium align-top" data-id="element-160">
                      <span className="inline-flex items-start gap-3" data-id="element-161">
                        <span className="flex-shrink-0 w-6 h-6 rounded-full bg-graphite border border-white/10 text-textsecondary text-xs font-bold flex items-center justify-center mt-0.5" data-id="element-162">
                          {i + 1}
                        </span>
                        {row.without}
                      </span>
                    </td>
                    <td className="p-5 text-energy font-semibold align-top bg-electric/[0.04] group-hover:bg-electric/[0.08] transition-colors border-l border-electric/20" data-id="element-163">
                      <span className="inline-flex items-start gap-2" data-id="element-164">
                        <AlertTriangle className="w-4 h-4 text-electric shrink-0 mt-0.5" data-id="element-165" />
                        {row.cost}
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        {/* Mobile cards */}
        <div className="max-w-2xl mx-auto mb-10 md:hidden space-y-3" data-id="element-166">
          {costData.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="bg-gradient-to-br from-petroleum to-graphite border border-electric/20 rounded-2xl overflow-hidden shadow-lg" data-id="element-167">
              <div className="px-5 py-3 bg-graphite/60 border-b border-white/10 flex items-center gap-2.5" data-id="element-168">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-graphite border border-white/10 text-textsecondary text-xs font-bold flex items-center justify-center" data-id="element-169">
                  {i + 1}
                </span>
                <p className="text-white font-semibold text-sm" data-id="element-170">
                  {row.without}
                </p>
              </div>
              <div className="px-5 py-4 bg-electric/[0.06]" data-id="element-171">
                <div className="inline-flex items-center gap-1.5 text-electric text-[10px] font-bold uppercase tracking-wider mb-1.5" data-id="element-172">
                  <AlertTriangle className="w-3 h-3" data-id="element-173" /> Costo real
                </div>
                <p className="text-energy text-sm font-semibold" data-id="element-174">{row.cost}</p>
              </div>
            </motion.div>)}
        </div>

        {/* Closing quote card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto" data-id="element-175">
          <div className="absolute -inset-0.5 bg-gradient-to-r from-gold/40 via-yellow-300/30 to-gold/40 rounded-2xl blur-lg opacity-40" data-id="element-176"></div>
          <div className="relative bg-gradient-to-br from-petroleum to-graphite border border-gold/40 rounded-2xl p-8 text-center shadow-[0_0_30px_rgba(232,184,74,0.12)]" data-id="element-177">
            <p className="text-base md:text-lg text-textsecondary mb-3" data-id="element-178">
              El próximo mes puede ser diferente.
            </p>
            <h3 className="text-xl md:text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 via-gold to-yellow-400 leading-snug flex items-center justify-center gap-3 flex-wrap" data-id="element-179">
              <Zap className="w-6 h-6 md:w-7 md:h-7 text-gold fill-gold drop-shadow-[0_0_8px_rgba(232,184,74,0.6)]" data-id="element-180" />
              <span data-id="element-181">
                "El próximo cliente que llegue puede ser el primero que tu
                sistema cierre en automático."
              </span>
            </h3>
            <div className="mt-5 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-gold to-transparent opacity-60" data-id="element-182"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}